import {Component} from '@angular/core';

@Component({
    selector: 'app-phone-number-field',
    templateUrl: './phone-number-field.component.html',
    standalone: false
})
export class PhoneNumberFieldComponent {
}
